export default {
  empty: {
    title: 'データがありません',
    description: '関連するデータはありません'
  },
  search: {
    title: '検索結果はありません',
    description: '検索条件を変更して再検索してください'
  }
};
